import { fetchApiDataV2, likeHandlerShorts,fetchApiData,updateApiData ,commentGifUpload,commentImageUpload} from "../../utils/utils";

export const getVerticalShowsList = async (appInfo, showIdentifier) => {
  const api = `verticalShows/${showIdentifier}`;
  return await fetchApiDataV2(appInfo, api);
};

export const likeHandler = async (id, liked, appInfo) => {
  const api = `like/video`;
  const data = {
    id,
    liked
  };
  return await likeHandlerShorts(api, data, appInfo);
};
export const commentReport = async (appInfo, data) => {
    const api = `communityV2/report`;
    return await updateApiData(appInfo, api, { values: data }, false );
}
export const deleteComment = async (appInfo, commentId, postId) => {
    const api = `communityV2/comments/${commentId}/delete`;
    return await updateApiData(appInfo, api, { values: { post_id: postId } } );
};
export const fetchCommentReplies = async (appInfo, commentId, { page, reply_id } = {}) => {
    const api = `communityV2/comments/${commentId}/replies`;
    const params = {};
    if (page) params.page = page;
    if (reply_id) params.reply_id = reply_id;
    return await fetchApiData(appInfo, api, params);
};
export const likeDislikeComment = async (appInfo, commentId, data) => {
    const api = `communityV2/comments/${commentId}/like`
    return await updateApiData(appInfo, api, { values: data })
};
export const commentGifUploadThumbnail = async (data,appInfo) =>{
    const api =`comments/gif`
  
    return await commentGifUpload(data,appInfo,api)
  };
export const commentImageUploadThumbnail = async (data,appInfo) =>{
    const api =`comments/image`
  
    return await commentImageUpload(data,appInfo,api)
  };
export const fetchComments = async (appInfo, params) => {
    const api = `communityV2/comments`
    return await fetchApiData(appInfo, api, params)
}
export const createComment = async (appInfo, data) => {
    const api = `communityV2/comments/create`
    return await updateApiData(appInfo, api, { values: data }, false)
};
export const editComment = async (appInfo, commentId, data) => {
    const api = `communityV2/comments/${commentId}/edit`
    return await updateApiData(appInfo, api, { values: data }, false)
};
